module.exports = __webpack_public_path__ + "img/Soft_supply_R3.44a9907c.jpg";